<template>
    <div class="mx-auto py-10">
        <h1 class="text-2xl mb-5">Callback Request</h1>
        <form @submit.prevent="submitForm" class="grid grid-cols-1 gap-6">
            <!-- Hidden Input for Account ID -->
            <input type="hidden" v-model="form.account_id"/>

            <!-- Row 1: Preferred Method of Contact -->
            <div>
                <label
                    for="preferredMethodOfContact"
                    class="block text-sm font-medium text-gray-700"
                >
                    Preferred Method of Contact:
                </label>
                <select
                    v-model="form.preferred_method_of_contact"
                    id="preferredMethodOfContact"
                    required
                    :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`"
                >
                    <option value="phone_call">Phone Call</option>
                    <option value="email">Email</option>
                </select>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <!-- Row 2: Reason for Contact -->
                <div>
                    <label
                        for="reasonForContact"
                        class="block text-sm font-medium text-gray-700"
                    >
                        Reason for Contact:
                    </label>
                    <select
                        v-model="form.reason_for_call"
                        id="reasonForContact"
                        required
                        :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`"
                    >
                        <option value="make_payment">Make Payment</option>
                        <option value="account_issue">Account Issue</option>
                        <option value="consumer_portal">Consumer Portal</option>
                    </select>
                </div>

                <div>
                    <label
                        for="relationToAccountHolder"
                        class="block text-sm font-medium text-gray-700"
                    >
                        Your Relation to Account Holder:
                    </label>
                    <select
                        v-model="form.relation"
                        id="relationToAccountHolder"
                        required
                        :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`"
                    >
                        <option value="primary_account_holder">
                            Primary Account Holder
                        </option>
                        <option value="representing_consumer">Representing Consumer</option>
                    </select>
                </div>
            </div>

            <span class="text-lg">Your Information</span>
            <!-- Row 3: Name and Phone Number -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label for="name" class="block text-sm font-medium text-gray-700">
                        Name:
                    </label>
                    <input
                        type="text"
                        id="name"
                        required
                        v-model="form.information.name"
                        :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`"
                    />
                </div>
                <div>
                    <label
                        for="phoneNumber"
                        class="block text-sm font-medium text-gray-700"
                    >
                        Phone Number:
                    </label>
                    <input
                        type="text"
                        id="phoneNumber"
                        v-model="form.information.phone_number"
                        :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`"
                    />
                </div>
            </div>

            <!-- Row 4: Email Address and Last 4 Digit of SSN -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label
                        for="emailAddress"
                        class="block text-sm font-medium text-gray-700"
                    >
                        Email Address:
                    </label>
                    <input
                        type="email"
                        id="emailAddress"
                        required
                        v-model="form.information.email_address"
                        :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`"
                    />
                </div>
                <div>
                    <label
                        for="last_four_ssn"
                        class="block text-sm font-medium text-gray-700"
                    >
                        Last 4 digit of SSN:
                    </label>
                    <input
                        type="text"
                        id="last_four_ssn"
                        v-model="form.information.last_four_ssn"
                        :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`"
                    />
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                    <label for="dob" class="block text-sm font-medium text-gray-700">
                        DOB:
                    </label>
                    <input
                        type="date"
                        id="dob"
                        v-model="form.information.dob"
                        :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`"
                    />
                </div>
                <div>
                    <label for="zip" class="block text-sm font-medium text-gray-700">
                        Zip Code:
                    </label>
                    <input
                        type="text"
                        id="zip"
                        v-model="form.information.zip"
                        :class="`bg-white py-3 px-4 shadow-sm focus:ring-${$root.theme}-400 focus:border-${$root.theme}-400 block w-full sm:text-sm border-gray-300 rounded-md placeholder-gray-300`"
                    />
                </div>
            </div>
            <div
                v-if="success || error"
                :class="[
          'rounded-md',
          'p-2',
          'text-xs',
          success
            ? 'bg-green-100 text-green-800 border border-green-200'
            : 'bg-red-100 text-red-800 border border-red-200',
        ]"
            >
                {{ message }}
            </div>

            <!-- Row 5: Submit Button -->
            <div>
                <button type="submit" :disabled="loading" :class="buttonClass">
                    {{ !loading ? 'Submit Request' : 'Submitting Request' }}
                </button>
            </div>
        </form>
    </div>
</template>

<script>
const defaultForm = {
    account_id: '',
    preferred_method_of_contact: '',
    reason_for_call: '',
    relation: '',
    information: {
        name: '',
        phone_number: '',
        email_address: '',
        last_four_ssn: '',
        dob: '',
        zip: '',
    },
};
export default {
    data() {
        return {
            message: '',
            success: false,
            error: false,
            loading: false,
            form: {...defaultForm, account_id: this.account.id},
        };
    },
    props: {
        account: {
            type: Object,
            required: true,
        },
        token: {
            type: String,
            required: true,
        },
    },
    computed: {
        buttonClass() {
            const baseClasses =
                'inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white sm:text-sm';
            const theme = this.$root.theme;

            if (this.loading) {
                return `${baseClasses} bg-${theme}-200 cursor-not-allowed`;
            } else {
                return `${baseClasses} bg-${theme}-400 hover:bg-${theme}-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-${theme}-300`;
            }
        },
    },
    methods: {
        async submitForm() {
            this.loading = true;
            try {
                const response = await this.$http.post(
                    `${this.consumerPortalBaseUrl}/api/contact-request/${this.account.id}`,
                    this.form
                );

                if (response?.body?.message) {
                    this.message = response.body.message;
                }

                if (response.status === 200) {
                    this.form = {
                        ...defaultForm,
                        account_id: this.account.id,
                    };
                    this.success = true;
                }
            } catch (error) {
                this.message =
                    error.body.error ||
                    'An unexpected error occurred. Please try again later.';
                this.error = true;
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
